let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aHiPU")).then(() => parcelRequire('1cvAC'));